// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { DEFAULT_DATE_FORMAT, DEFAULT_DATETIME_FORMAT, DEFAULT_TIME_FORMAT } from 'utils/time-utils';
import { Form } from 'semantic-grab-ui/src';
import './CDatePicker.scss';

export default class CDatePicker extends Component {
  props: Object;

  constructor(props: Object) {
    super(props);
    this.defaultProps = {
      control: DatePicker,
      timeIntervals: 15,
      timeFormat: DEFAULT_TIME_FORMAT,
      onChange: this.onDateChange,
      onBlur: this.onDateBlur,
      injectTimes: [moment().hours(23).minutes(59).seconds(59)],
      readOnly: true,
      disabled: false,
    };
  }

  onDateChange = (date: moment) => {
    if (!this.props.disableAutoSetEndTimeSeconds && [29, 59].includes(date.minutes())) {
      date.seconds(59).milliseconds(0);
    } else {
      date.seconds(0).milliseconds(0);
    }
    this.props.handleInputChange({}, { name: this.props.name, value: date });
  }

  onDateBlur = () => {
    if (this.props.handleControlBlur) {
      const date = this.props.selected;
      if (!this.props.disableAutoSetEndTimeSeconds && [29, 59].includes(date.minutes())) {
        date.seconds(59).milliseconds(0);
      } else {
        date.seconds(0).milliseconds(0);
      }
      this.props.handleControlBlur({}, { name: this.props.name, value: date });
    }
  }

  getDateFormat() {
    const { showTimeSelect, timeFormat } = this.props;

    if (!_.isEmpty(timeFormat)) {
      return timeFormat;
    }

    return showTimeSelect ? DEFAULT_DATETIME_FORMAT : DEFAULT_DATE_FORMAT;
  }

  render() {
    const { showTimeSelect, disabled } = this.props;
    const newProps = {
      ...this.defaultProps,
      dateFormat: this.getDateFormat(),
      className: showTimeSelect ? 'date-time' : '',
      ..._.omit(this.props, ['disableAutoSetEndTimeSeconds']),
      disabled,
    };
    return <Form.Input {...newProps} />;
  }
}
